import { Box, Chip, Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useRoles } from 'src/hooks';
import useResolution from 'src/hooks/useResolution';

type RoleOption = {
  label: string;
  value: string;
  description: string;
  color: string;
};

type RoleChipProps = {
  roles: string[];
  roleOptions: RoleOption[];
};

const RoleChip: React.FC<RoleChipProps> = ({ roles, roleOptions }) => {
  const { isMobile, isIPadAir } = useResolution();
  const { getRoles } = useRoles();
  const userRoles = getRoles(...roles);

  const roleColor = useCallback(
    (role?: string) => {
      const selectedColor = roleOptions?.find(
        (option) => option.value.toLowerCase() === role?.toLowerCase()
      )?.color;
      return typeof selectedColor === 'string' ? selectedColor : '#000000';
    },
    [roleOptions]
  );

  if (!userRoles) return null;

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      style={{ marginLeft: 5, marginTop: -3, gap: isMobile || isIPadAir ? '4px' : '8px' }}
      mt={1}
    >
      {userRoles.map((role: any) => (
        <Chip
          key={role.name}
          style={{
            color: roleColor(role.name),
            borderColor: roleColor(role.name)
          }}
          label={
            <Typography variant="subtitle2">
              {role.name?.toUpperCase()}
            </Typography>
          }
          size="medium"
          variant="outlined"
        />
      ))}
    </Box>
  );
};

export default RoleChip;
